import { render, staticRenderFns } from "./LeaderboardBlock.vue?vue&type=template&id=31419ed0&"
import script from "./LeaderboardBlock.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports